import "./Loader.scss";

export const Loader = () => <div className="loader"></div>;
